export const popups = {
  registerRequest: {
    title: 'Solicitud de registro',
    description:
      'Complete el cuestionario y nos pondremos en contacto con usted.',
    button: 'Dejar una solicitud de registro',
    form: {
      noteLabel: '¿Cómo aprendiste sobre nosotros?',
      notePlaceholder: '¿Cómo aprendiste sobre nosotros?',
      checkboxExperience: 'Estoy con experiencia en el club',
      club: {
        nameLabel: 'El nombre del club',
        namePlaceholder: 'El nombre del club'
      }
    }
  },
  invite: {
    title: 'Confirmar edad',
    description: '¿Tienes 18 años? Confirma tu edad para usar la plataforma.',
    confirm: 'Sí, tengo 18'
  },
  deleteAccount: {
    title: '¿Eliminar la cuenta?',
    subTitle: 'Será imposible cancelar la eliminación.',
    description:
      'En lugar de eliminar, el perfil se puede ocultar. No estará disponible para nadie excepto usted hasta que decida abrirlo.'
  },
  exitFromProfile: {
    title: '¿Cerrar sesión?',
    description: 'Confirma que deseas cerrar sesión.'
  },
  hideAccount: {
    title: '¿Ocultar perfil?',
    description:
      'Tu perfil no será visible para nadie excepto tú hasta que decidas reabrirlo.'
  },
  mainPhoto: {
    title: 'Foto de portada',
    description: 'Elige una foto de portada para tu currículum'
  },
  updateVideo: {
    title: 'Subida de video',
    description: 'Espera a que se suba el video'
  },
  consumation: {
    title: 'Consumo',
    description:
      'Ingrese las 5 posiciones más populares de la consumo cuánto cada posición y porcentaje del precio por los pagos a los costos del artista.'
  },
  crazyMenu: {
    title: 'Menú loco',
    description:
      'Ingrese las 5 posiciones más populares del menú Crazy y el costo de cada uno.'
  },
  warningOnCloseOnboarding: {
    title: '¿Seguro?',
    description:
      '¿Seguro que quieres dejar de completar los datos? Tu currículum no se publicará. Los clubes no podrán enviarte sus mejores ofertas. Podrás continuar más tarde.'
  },
  foreignLanguage: {
    title: 'Nivel de dominio'
  },
  createWorkItem: {
    title: 'Confirmar invitación',
    titleRequest: 'Confirmar solicitud',
    inviteDescription:
      'Se alega esta información. Puedes discutirla en una conversación con un artista y actualizar su invitación.',
    requestDescription:
      'Se alega esta información. Puede discutirla en un chat con un club y actualizar la aplicación.',
    suggestVacancy: 'Ofrecer una vacante para el artista',
    selectVacancy: 'Indicar la vacante de interés',
    ticketCreditOption: 'La posibilidad de prestar a un boleto',
    ticketCreditRequired: '¿Necesito un préstamo de boletos?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'El artista trabaja en tu club.',
    setLastDay: {
      title: '¿Establecer último día de trabajo?',
      setLastWorkDate: 'Indique la fecha del último día hábil del artista',
      description:
        'Habiendo establecido la última fecha para el artista, no se puede cambiar. Después de la fecha establecida, el artista completará el contrato en su club.'
    },
    artistArrival: {
      title: '¿Confirmar la presencia del artista?',
      description: 'Confirma la presencia del artista en su club',
      information:
        'El trabajo comenzará desde el momento en que confirme la presencia del artista en el lugar de trabajo.'
    },
    workCancel: {
      title: '¿Cancelar contrato?',
      description: 'Confirma la cancelación del contrato'
    },
    wantEndDate: {
      title: 'El artista quiere obtener la última fecha.'
    },
    newEndDate: {
      title: 'Último día de trabajo'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Su solicitud de finalización del contrato está bajo consideración.',
      workStartOnArtistArrivalConfirm:
        'El trabajo comenzará desde el momento en que el club confirma su presencia en el lugar de trabajo.',
      weCanRequestLastWorkDate:
        'Solicita la fecha de finalización del contrato al club.',
      clubSetLastWorkDate:
        'El club estableció su última fecha de trabajo en este club.'
    }
  },
  changeProfile: {
    title: 'Mis clubes'
  },
  confirmOnboardingCompletion: {
    title: 'Tu portafolio se ha publicado',
    description: 'Ahora los clubes podrán invitarte a trabajar.'
  },
  videoUploading: {
    title: 'Subida de video',
    description: 'Espera a que se suba el video'
  },
  addWorkItem: {
    title: 'Lugar de trabajo',
    vacancyQuestion: '¿Para qué vacantes trabajaste?',
    validationMessage:
      'Ya ha establecido que está trabajando en tiempo presente.'
  },
  selectMainPhoto: {
    title: 'Foto principal',
    description: 'Especifica una foto de portada para tu currículum'
  },
  deleteWorkExperience: {
    title: '¿Eliminar?',
    description: '¿Estás seguro de que deseas eliminar esta experiencia laboral?'
  }
};
